import type { ReactNode } from 'react'

import styles from './TestModal.module.scss'

interface TestModalProps {
    isOpen: boolean
    onClose: () => void
    title: string
    description?: string
    children: ReactNode
    footer?: ReactNode
}

/**
 * Shared modal component for testing utilities
 * Provides consistent styling and behavior for test modals
 */
export const TestModal = ({
    isOpen,
    onClose,
    title,
    description,
    children,
    footer,
}: TestModalProps) => {
    if (!isOpen) return null

    return (
        <div className={styles.modalOverlay} onClick={onClose}>
            <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
                <h2 className={styles.modalTitle}>{title}</h2>
                {description && (
                    <p className={styles.modalDescription}>{description}</p>
                )}
                <div className={styles.modalContent}>{children}</div>
                {footer && <div className={styles.modalFooter}>{footer}</div>}
            </div>
        </div>
    )
}
